import { ArrowBack } from "@material-ui/icons";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import axios from "axios";
import { CurrencyDisplay, CustomTable, ModalError } from "components";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalRevenueInformation = ({ open, onClose }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/transaction/v2/balance/detail`,
        { headers, params: queryParams }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response)).then(() => onClose());
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Grid container columnGap={1}>
          <Grid item>
            <IconButton onClick={onClose}>
              <ArrowBack />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography fontSize={24} fontWeight={700}>
              Revenue Information
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <CustomTable
          columnTable={columnTable}
          data={dataTable}
          items={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isLoading={loadingPage}
          maxHeight={400}
          skeletonHeight={500}
        />
      </DialogContent>
    </Dialog>
  );
};
const columnTable = [
  {
    name: "song_title",
    title: "Song",
    renderText: item => item || "-",
  },
  {
    name: "total_value",
    title: "Total Revenue",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
  {
    name: "remaining_value",
    title: "Remaining Balance",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
];
export default ModalRevenueInformation;
